import React from 'react';
import PropTypes from 'prop-types';
import ButtonPrimary from '../ButtonPrimary';
import './styles.scss';

const ButtonPrimaryCompact = ({ classNames = [], ...props }) => (
    <ButtonPrimary {...props} classNames={['custom-btn-primary-compact', ...classNames]} />
);

ButtonPrimaryCompact.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonPrimaryCompact;
